var map = {
	"./WhatsApp Image 2024-12-10 at 4.43.21 PM.jpeg": 22788,
	"./WhatsApp Image 2024-12-10 at 4.43.23 PM (1).jpeg": 11808,
	"./WhatsApp Image 2024-12-10 at 4.43.23 PM.jpeg": 94310,
	"./WhatsApp Image 2024-12-11 at 10.41.08 AM.jpeg": 80868
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 99232;